export default "__VITE_ASSET__4cd86ebc__"